import React from "react";
import {
  Typography,
  Box,
  Rating,
  Stack,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import DiscountIcon from "@mui/icons-material/Discount";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import VerifiedIcon from "@mui/icons-material/Verified";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ShareIcon from "@mui/icons-material/Share";
import PolicyBadges from "../../pages/vendor/PolicyBadges";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

const badgeStyle = {
  display: "flex",
  alignItems: "center",
  gap: 0.5,
  px: 1,
  py: 0.5,
  bgcolor: "#f0f2f2",
  borderRadius: 1,
  fontSize: 12,
  fontWeight: 600,
};

const ProductInfo = ({
  product,
  wishlisted,
  toggleWishlist,
  liked,
  setLiked,
  handleShare,
  badges,
  ratingSummary,
}) => {
  const { title, description, price, rating, ratingCount } = product;
  
  // Use ratingSummary if available, otherwise fall back to product.rating/ratingCount
  const displayRating = ratingSummary?.average || rating || 0;
  const displayRatingCount = ratingSummary?.total || ratingCount || 0;

  return (
    <>
      <Typography variant="h5" fontWeight={700}>
        {title}
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
        {displayRating > 0 ? (
          <>
            <Rating value={displayRating} precision={0.5} size="small" readOnly />
            <Typography variant="body2" color="text.secondary">
              ({displayRatingCount} ratings)
            </Typography>
          </>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No ratings yet
          </Typography>
        )}
      </Box>

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <Box sx={badgeStyle}>
          <DiscountIcon fontSize="small" /> 10% OFF
        </Box>
        <Box sx={badgeStyle}>
          <LocalShippingIcon fontSize="small" /> Free Delivery
        </Box>
        <Box sx={badgeStyle}>
          <VerifiedIcon fontSize="small" /> Assured
        </Box>
      </Stack>

      <Divider sx={{ my: 2 }} />

      <Typography variant="h6" color="#B12704" fontWeight={700}>
        ₹ {Number(price).toLocaleString("en-IN")}
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          mt: 1,
          "& p": { margin: 0 },
        }}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(description),
        }}
      />

      <PolicyBadges badges={badges} singleLine={true} />

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {wishlisted ? (
          <IconButton onClick={() => toggleWishlist(product)}>
            <FavoriteIcon color="error" />
          </IconButton>
        ) : (
          <Tooltip title="Add to your Wishlist">
            <IconButton onClick={() => toggleWishlist(product)}>
              <FavoriteBorderIcon />
            </IconButton>
          </Tooltip>
        )}
        <IconButton onClick={() => setLiked(!liked)}>
          {liked ? <ThumbUpIcon /> : <ThumbUpOffAltIcon />}
        </IconButton>
        <IconButton onClick={handleShare}>
          <ShareIcon />
        </IconButton>
      </Stack>
    </>
  );
};

export default ProductInfo;